<template>
    <zen-one :showuserinfo="false" :title="'Dashboard Kaunter'" :crumbs="crumbs">
        <w-flex class="grow justify-space-betweenx basis-zero mb3">
            <div  class="box maa bd1 mr3">
                <div class="primary-light1 white py3">
                    <w-flex column align-center justify-space-between class="wrapper">
                        <div>JUMLAH KUTIPAN HARI INI</div>
                        <div><h3>RM 400,000.00</h3></div>
                        <div style="color: green">
                            <w-icon class="mr2" sm>
                            fal fa-arrow-up
                            </w-icon>    (45.50%)
                        </div>
                    </w-flex>
                </div>
            </div>
            <div  class="box maa bd1 mr3">
                <div class="primary-light1 white py3">
                    <w-flex column align-center justify-space-between class="wrapper">
                        <div>JUMLAH KUTIPAN SEMALAM</div>
                        <div><h3>RM 125,000.00</h3>
                        </div>
                        <div style="color: green">
                            <w-icon class="mr2" sm>
                            fal fa-arrow-up
                            </w-icon>    (10.20%)
                        </div>
                    </w-flex>
                </div>
            </div>
            <div  class="box maa bd1 ">
                <div class="primary-light1 white py3">
                    <w-flex column align-center justify-space-between class="wrapper">
                        <div>PURATA KUTIPAN HARIAN SEPANJANG TAHUN SEMASA</div>
                        <div><h3>RM 25,000.00</h3></div>
                        <div style="color: red">
                            <w-icon class="mr2" sm>
                            fal fa-arrow-down
                            </w-icon>    (15.20%)
                        </div>
                    </w-flex>
                </div>
            </div>
        </w-flex>
        <w-flex class="grow justify-space-betweenx basis-zero mb3">
            <div class="box mr3 bd1">
                        <!-- <z-dashboard-item
                            class="box mb3 mr3"
                            style="width:100%"
                            :use-icon="false"
                            :use-slot="true"
                            > -->
                    <div class="dashboard-title">Senarai Kutipan Mengikut Cara Bayaran</div>
                    <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada Hari Ini</div>
                    <!-- <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> -->

                    <table style="width:100%" class="mb2 table-dashboard">

                        <thead >
                        <tr>
                            <td width="10%" class="text-center">#</td>
                            <td >
                                <i class="w-icon fal fa-money size--sm mr2" role="icon" aria-hidden="true"></i>
                                Cara Bayaran (RM)
                            </td>
                            <td >
                                <i class="w-icon fal fa-dollar-sign size--sm mr2" role="icon" aria-hidden="true"></i>
                                Amaun (RM)</td>
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="kt in kutipan" :key="kt">
                            <td>{{kt.id}}</td>
                            <td>{{kt.cb}} - {{kt.perihal}}</td>
                            <td class="text-right">{{formatPrice(kt.amaun)}}</td>
                        </tr>
                        <tr v-if="resitBatal">
                            <td class="text-right" colspan="2" rowspan="1"><b>Jumlah Kutipan</b></td>
                            <td class="text-right" colspan="3" rowspan="1">{{formatPrice(totalCollection(kutipan))}}</td>
                        </tr>
                    </tbody>
                    </table>
                <!-- </z-dashboard-item> -->
            </div>
            <div class="box">
                <z-dashboard-item
                            class="box mb3"
                            style="width:100%; height: 100%"
                            :use-icon="false"
                            :use-slot="true"
                            >
                    <fusioncharts
                    :type="datafusion.type"
                    :width="datafusion.width"
                    :height="datafusion.height"
                    :dataFormat="datafusion.dataFormat"
                    :dataSource="datafusion.dataSource"
                    ></fusioncharts>
                </z-dashboard-item>

            </div>
        </w-flex>
        <w-flex class="grow justify-space-betweenx basis-zero mb3" >
            <div class="box mr3 bd1">
                        <!-- <z-dashboard-item
                            class="box mb3 mr3"
                            style="width:100%"
                            :use-icon="false"
                            :use-slot="true"
                            > -->
                    <div class="dashboard-title">Senarai Resit Batal</div>
                    <div class="dashboard-subtitle mt1 mb3">Keseluruhan pada Hari Ini</div>
                    <!-- <button class="dashboard-more"> Lanjut <i class="fal fa-angle-double-right ml2"></i></button> -->

                    <table style="width:100%" class="mb2 table-dashboard">

                        <thead >
                        <tr>
                            <td width="10%" class="text-center">#</td>
                            <td >
                                <i class="w-icon  size--sm mr2" role="icon" aria-hidden="true"></i>
                                Jenis Perserahan
                            </td>
                            <td >
                                <i class="w-icon  size--sm mr2" role="icon" aria-hidden="true"></i>
                                Id. Hakmilik / Urusan
                            </td>
                            <td >
                                <i class="w-icon  size--sm mr2" role="icon" aria-hidden="true"></i>
                                No. Resit
                            </td>
                            <td>
                                <i class="w-icon  size--sm mr2" role="icon" aria-hidden="true"></i>
                                Cara Bayaran
                            </td>
                            <td>
                                <i class="w-icon fal fa-dollar-sign size--sm mr2" role="icon" aria-hidden="true"></i>
                                Amaun (RM)
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="rb in resitBatal" :key="rb">
                            <td>{{rb.id}}</td>
                            <td>{{rb.jnspsrh}}</td>
                            <td class="text-right">{{rb.idHakmilik}}</td>
                            <td class="text-right">{{rb.resit}}</td>
                            <td class="text-right">{{rb.cb}}</td>
                            <td class="text-right">{{formatPrice(rb.amaun)}}</td>
                        </tr>
                        <tr v-if="resitBatal">
                            <td class="text-right" colspan="5" rowspan="1"><b>Jumlah Resit Batal</b></td>
                            <td class="text-right" colspan="1" rowspan="1">{{formatPrice(totalCollection(resitBatal))}}</td>
                        </tr>
                    </tbody>
                    </table>
                <!-- </z-dashboard-item> -->
            </div>
        </w-flex>
    </zen-one>
</template>

<script>

const dataSource = {
  chart: {
    caption: "Carta Perbandingan Kutipan Mingguan Ikut Cara Bayaran",
    yaxisname: "% of youth on this platform",
    subcaption: "24/4 - 28/4",
    showhovereffect: "1",
    // numbersuffix: "%",
    drawcrossline: "1",
    plottooltext: "<b>$dataValue</b> bayar menggunakan $seriesName",
    theme: "fusion"
  },
  categories: [
    {
      category: [
        {
          label: "Ahad"
        },
        {
          label: "Isnin"
        },
        {
          label: "Selasa"
        },
        {
          label: "Rabu"
        },
        {
          label: "Khamis"
        }
      ]
    }
  ],
  dataset: [
    {
      seriesname: "Tunai",
      data: [
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        }
      ]
    },
    {
      seriesname: "Bank Deraf",
       data: [
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        }
      ]
    },
    {
      seriesname: "Kad Debit",
       data: [
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        }
      ]
    },
    {
      seriesname: "Kad Kredit",
       data: [
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        }
      ]
    },
    {
      seriesname: "TNG eWallet",
       data: [
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        },
        {
          value: Math.floor(Math.random() * 50000) + 500
        }
      ]
    },
    {
      seriesname: "GrabPay",
       data: [
        {
          value: Math.floor(Math.random() * 12000) + 500
        },
        {
          value: Math.floor(Math.random() * 12000) + 500
        },
        {
          value: Math.floor(Math.random() * 12000) + 500
        },
        {
          value: Math.floor(Math.random() * 12000) + 500
        },
        {
          value: Math.floor(Math.random() * 12000) + 500
        }
      ]
    },
  ]
};

export default {
    components: {

    },
    data() {
        return {
            kutipan: [
                {
                    id: 1,
                    cb: "T",
                    perihal: "Tunai",
                    amaun: 45000.00
                },
                {
                    id: 2,
                    cb: "BD",
                    perihal: "Bank Deraf",
                    amaun: 200000.00
                },
                {
                    id: 3,
                    cb: "KD",
                    perihal: "Kad Debit",
                    amaun: 350000.00
                },
                {
                    id: 4,
                    cb: "KK",
                    perihal: "Kad Kredit",
                    amaun: 2500000.00
                },
                {
                    id: 5,
                    cb: "TG",
                    perihal: "TNG eWallet",
                    amaun: 15000.00
                },
                {
                    id: 6,
                    cb: "GP",
                    perihal: "GrabPay",
                    amaun: 9000.00
                },
            ],
            datafusion: {
                type: "msline",
                width: "100%",
                height: "80%",
                dataFormat: "json",
                dataSource
            },
            resitBatal: [
                {
                    id: 1,
                    jnspsrh: "Cukai Tanah",
                    idHakmilik: "020103GM12345678",
                    resit: "20220428AC020001",
                    cb: "Tunai",
                    amaun: 200
                },
                {
                    id: 2,
                    jnspsrh: "Strata",
                    idHakmilik: "020103GM12345678001001M01001",
                    resit: "20220428AC020002",
                    cb: "Kad Kredit",
                    amaun: 500
                },
                {
                    id: 3,
                    jnspsrh: "Pelbagai",
                    idHakmilik: "Carian Persendirian",
                    resit: "20220428AC020003",
                    cb: "TNG eWallet",
                    amaun: 30
                },
            ],
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Dashboard Kaunter", route: "/" },
            ],
        }
    },
    methods: {
        formatPrice(value) {
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        totalCollection: function (values) {
            return values.reduce((acc, val) => {
                return acc + parseInt(val.amaun);
            }, 0);
        }
    }
}
</script>

<style>
.dashboard-box .w-image {
    background-size: contain;
}
.zdiimage {
    margin-right: 7px;
}
.dashboard-title {
    font-size: 17px;
    font-weight: bold;
    text-transform: uppercase;
}
.dashboard-percentage {
    position: absolute;
    right: 15px;
    font-weight: bold;
    font-size: 20px;
}
.dashboard-percentage-no {
    font-size: 20px;
}
.dashboard-more {
    position: absolute;
    right: 20px;
    top: 30px;
    color: #fff;
    background: #1f2248;
    padding: 3px 15px;
    border-radius: 5px;
    border: none;
}
</style>